module.exports = __webpack_public_path__ + "e43a0126bf5e599952407d146d0a3bef.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/social/speakers/sarah-drasner.jpg
// module id = 524
// module chunks = 0